import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, TextField } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import CustomButton from '../common/CustomButton';
import UploadViewFile from '../common/asset/UploadViewFile';
const EditPost = ({ postItem, handleSave, handleCancel, }) => {
    const [content, setContent] = React.useState(postItem?.content || '');
    const [selectedAsset, setSelectedAsset] = React.useState(postItem?.attachment || null);
    const [isUploading, setIsUploading] = React.useState(false);
    const store = useStore();
    const save = async () => {
        const newValues = { content };
        if (selectedAsset) {
            newValues.attachment = selectedAsset;
        }
        postItem.updateValues(newValues);
        handleSave(postItem);
    };
    return (_jsxs(Box, { id: `box-id-${postItem?.key || 'ROOT'}`, children: [_jsx(TextField
            // label={label}
            , { 
                // label={label}
                sx: { width: '100%', p: 1 }, value: content, size: "small", onChange: (e) => setContent(e.target.value), multiline: true, rows: 3, placeholder: "Enter your post" }), _jsx(Box, { sx: { mb: 2 }, children: _jsx(UploadViewFile, { repository: store.currentRepository, asset: selectedAsset, onAssetChange: (asset) => {
                        setSelectedAsset(asset);
                    }, onUploadStateChange: (state) => {
                        // Disable Save while the file is uploading
                        setIsUploading(state === 'Uploading');
                    }, uploadPrefix: `public/discussionGroup/${postItem?.key}/attachment` }) }), _jsxs(Box, { sx: { ml: 1, display: 'flex', justifyContent: 'flex-end' }, children: [_jsx(CustomButton, { label: "Cancel", onClick: handleCancel }), _jsx(CustomButton, { label: "Send", onClick: save, disabled: isUploading })] })] }));
};
export default observer(EditPost);
//# sourceMappingURL=EditPost.js.map